import { getUserToken } from '@/functions.js'
import { performRequest_POST } from '@/platform/utils/http/httpService'
import { getServerApi } from '@/config/deployment'
const Chat = require('twilio-chat');

let envUri = getServerApi()
let chatTokenUri = envUri + '/api/chat/token'

const fetchAccessToken = async (handler) => {
    return getUserToken()
        .then(token => {
            var headers = { "Authorization": token };
            var data = {}
            return performRequest_POST(chatTokenUri, data, headers)
        })
        .then(resp => {          
            if (resp.success) {
                if (handler) handler(resp.response.data.token)
                else return resp.response.data.token
            }
            else throw resp.error
        })
        .catch(err => {
            console.error("fetchAccessToken > err:", err)
        })

}

const connectMessagingClient = (token) => {
    return Chat.Client.create(token)
        .then(client => {
            return client;
        });
}

export { fetchAccessToken, connectMessagingClient }


// WEBPACK FOOTER //
// ./src/third-party/twilio/chat/services/twiliochat.js